import { literal, number, object, preprocess, string } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { ChallengeAwardSchema } from './award.schema';
import { BaseChallengeSchema } from './base-challenge.schema';

import { ChallengeType } from '../constants';

export const VisitChallengeEarningMechanismSchema = object({
  id: string().optional(),
  visitThreshold: number({ required_error: IS_REQUIRED }).positive(IS_POSITIVE),
});

export const VisitChallengeFormSchema = BaseChallengeSchema.extend({
  challengeType: literal(ChallengeType.VisitChallenge),
  visitChallenge: preprocess((val) => val ?? {}, VisitChallengeEarningMechanismSchema),
  award: preprocess((val) => val ?? {}, ChallengeAwardSchema),
});
